<style>
	 @import '@/assets/css/custom.css';
</style>

<template>
    <div>
        <Breadcrumbs main="" title="Vendors" />

		<div class="container-fluid">
			<div class="row">
				<div class="col-sm-12">
					<div class="card">
						<div class="card-body">

							<div class="col-md-12 project-list page-subtitle">
								<div class="row">
									<div class="col-md-12">
										<button class="btn btn-primary float-end" type="button" data-original-title="test" @click="openModal">Add Vendor</button>
									</div>
								</div>
							</div>

							<div class="col-md-12 project-list filter-sort">
								<div class="row">
									<div class="col-md-8 d-flex mt-2">
										<label class="d-flex listing-length ms-1"><span>Show</span>
											<!-- <select class="form-control" v-model="listing_length" @change="fetchUsers()"> -->
											<select class="form-select" v-model="listing_length" @change="fetchVendors()">
												<option value="5">5</option>
												<option value="10">10</option>
												<option value="20">20</option>
											</select>
											<span>entries</span>
										</label>
									</div>
									
									<div class="col-md-2 mt-2">
										<select class="form-select" v-model="status" @change="fetchVendors()">
											<option value="">All</option>
                                            <option value="1">Active</option>
                                            <option value="2">Blocked</option>
										</select>
									</div>
									<div class="col-md-2 mt-2">
										<input type="text" class="form-control ms-1" placeholder="Search" v-model="keyword" @keyup="fetchVendors()"/>
									</div>
								</div>
							</div>

							<div class="table-responsive product-table">
								<table class="display" id="basic-1">
									<thead>
										<tr align="center">
                                            <th>ID</th>  
                                            <th>Name</th>
											<th>Contact</th>
											<th>Type</th>
											<th>Options</th>
                                        </tr>
									</thead>
									<tbody v-if="Boolean(vendors.length)">
                                        <tr align="center" v-for="(vendor, index) in vendors" :key="vendor.id">
                                            <td>#{{vendor.id}}</td>
                                            <td>{{vendor.name}}</td>
											<td>{{vendor.mobile}} <br>
												{{vendor.email}}
											</td>
											<td>{{ vendor.vendor_type == 1 ? 'Manufacturer' : vendor.vendor_type == 2 ? 'Enclosure' : vendor.vendor_type == 3 ? 'Store' : 'N/A' }}</td>
											<td>
												<router-link :to="{ name: 'vendor_details',params:{id:vendor.id} }" class="btn btn-primary me-1 mb-2 btn-sm">Profile</router-link>
												<router-link :to="{ name: 'vendor_materials',params:{id:vendor.id} }" class="btn btn-primary me-1 mb-2 btn-sm">Raw Materials</router-link>
												<button class="btn btn-primary btn-sm me-1 mb-2" @click="editVendor(vendor)">Edit</button>
												<!--<a class="btn btn-danger me-1 mb-2 btn-sm" @click="deleteVendor(vendor.id)">Delete</a>-->
                                            </td>
                                        </tr>

									</tbody>
									<tbody v-else>
										<tr>
											<td colspan="12" align="center">No data available</td>
										</tr>

									</tbody>
								</table>
							</div>

							<!----pagination starts --->
							<caption v-if="Boolean(vendors.length)" class="float-start mt-2 d-block d-lg-inline">Showing {{this.from}} to {{this.to}} of {{this.total}} entries</caption>
							<nav aria-label="Page navigation" class="mt-2 float-end">
								<ul class="pagination">
									<li class="page-item" v-bind:class="[{ disabled: !page.url }, { active: page.active }]" v-for="(page, index) in pagination" :key="page.label">
										<a class="page-link" href="#" @click.prevent="fetchVendors(page.url + '&limit=' + listing_length + '&keyword=' + keyword)" tabindex="-1">
											<span v-if="index == 0">Prev</span>
											<span v-else-if="index == pagination.length - 1">Next</span>
											<span v-else>{{ page.label }}</span>
										</a>
									</li>
								</ul>
							</nav>
							<!----pagination ends --->
							
						</div>
					</div>
				</div>
			</div>
		</div>

		<DynamicModal :title="modal_title">
			<template #body>
				<form @submit.prevent="addVendor" enctype="multipart/form-data">

					<div class="row mt-2">
						<div class="col-md-12 form-group">
							<label class="control-label">Vendor Name<span class="text-danger">*</span></label>
							<input class="form-control" v-model="vendor.name" type="text" placeholder="" />
						</div>
					</div>

					<div class="row mt-2">
						<div class="col-md-12 form-group">
							<label class="control-label">Mobile<span class="text-danger">*</span></label>
							<input class="form-control" v-model="vendor.mobile" v-mobile-limit placeholder="" maxlength="10" minlength="10" />
						</div>	
					</div>

					<div class="row mt-2">
						<div class="col-md-12 form-group">
							<label class="control-label">Email<span class="text-danger">*</span></label>
							<input class="form-control" v-model="vendor.email" type="text" placeholder="" />
						</div>	
					</div>

					<div class="row mt-2">
						<div class="col-md-12 form-group">
							<label class="control-label">Vendor Type<span class="text-danger">*</span></label>
							<select class="form-select" v-model="vendor.vendor_type">
								<option value="">--select--</option>
								<option value="1">Manufacturer</option>
								<option value="2">Enclosure Unit</option>
								<option value="3">Store</option>
							</select>
						</div>
					</div>

					<div class="col-md-12 form-group mt-3">
						<button type="submit" class="btn btn-primary me-3" :disabled="submitting">
							<span v-if="submitting" class="spinner-border spinner-border-sm me-2" role="status" aria-hidden="true"></span>
							{{ submitting ? "Saving..." : button_title }}
						</button>
						<button type="button" class="btn btn-light" @click="closeModal()" :disabled="submitting">Close</button>
					</div>
				</form>
			</template>
		</DynamicModal>

	</div>
</template>

<script>
import {
    Tooltip
} from 'bootstrap/dist/js/bootstrap.esm.min.js'
import { onMounted } from 'vue'
import {Modal} from "bootstrap"
import DynamicModal from '@/components/dynamic_modal.vue'
	let dynamicmodal;

	export default {
		name: "User Page",
		components: {
			DynamicModal
		},
		setup(){
			onMounted(() => {
				dynamicmodal = new Modal(document.getElementById('dynamicmodal'));
			})

			const showModal = () => {
				dynamicmodal.show();
			}

			const hideModal = () => {
				dynamicmodal.hide();
			}

			return {
				showModal, hideModal
			}
		},

		data() {
			return {
				
				modal_title: "Add Vendor",
				button_title: "Save",
				
				keyword: "",
				showsearch: false,
				listing_length: 10,
				token: "",
				status:"",
				submitting: false,
				errors: {},

				vendors:[],

				vendor:{
					id:"",
					name:"",
					email:"",
					mobile:"",
					vendor_type:"",
				},

                button_title: "Save",
			
			};
		},

		mounted() {
            new Tooltip(document.body, {
                    selector: "[data-bs-toggle='tooltip']",
                })
        },
        unmounted() {

            let popovers = document.getElementsByClassName('tooltip')
            // popovers.forEach(item => {
            //     item.remove()
            // })

        },

		created() {

			this.fetchVendors();

		},
		methods: {

			getToken() {
				if (localStorage.getItem('airotrack_staff')) {
					var airotrack_staff =  JSON.parse(localStorage.getItem('airotrack_staff')); 
							
					if(airotrack_staff.token) {

						this.token = airotrack_staff.token;
						this.user = airotrack_staff;

					} else {
						this.$swal("", "Failed to fetch token, please login again", "error");
						this.$router.push({ name: "login" });
					}

				} else {
					this.$swal("", "Session expired, please login again", "error");
					this.$router.push({ name: "login" });
				}
			},
			
			fetchVendors(page_url = null) {
				this.getToken();
				let url = "/staffs/vendors?limit=" + this.listing_length  + "&keyword=" + this.keyword;
				page_url = page_url || url;
				this.active_page_url = page_url;
				this.$axios
					.get(page_url, { headers: { Authorization: "Bearer " + this.token } })
					.then((res) => {
						var responseData = res.data.data;
						console.log(responseData);
						this.vendors = responseData.vendors.data;
						this.pagination = responseData.vendors.links;
						this.from = responseData.vendors.from;
						this.to = responseData.vendors.to;
						this.total = responseData.vendors.total;
						
					})
					.catch((err) => console.log(err));
			},
			
			openModal() {
				this.showModal();
			},

			closeModal() {
				this.hideModal();
			},

            editVendor(vendor) {
				this.edit = true;
                this.errors = {};
                this.modal_title = "Edit Vendor";
                this.button_title = "Update";
                this.vendor = {
					id:vendor.id,
                    name: vendor.name,
                    mobile: vendor.mobile,
                    email: vendor.email,
                    vendor_type: vendor.vendor_type
                };
                this.showModal();
            },

			addVendor() 
			{
				if (this.submitting) return;
				this.submitting = true;
				this.getToken();
				let formData = new FormData();
                formData.append("name", this.vendor.name);
                formData.append("mobile", this.vendor.mobile);
                formData.append("email", this.vendor.email);
                formData.append("vendor_type", this.vendor.vendor_type);
				const config = {
					headers: {
						"content-type": "multipart/form-data",
						Authorization: "Bearer " + this.token,
					},
				};
				let url;
				if (!this.edit) {
					url = "/staffs/addVendor";
					this.active_page_url = null;
				} else {
					url = "/staffs/updateVendor";
					formData.append("vendor_id", this.vendor.id);
				}
				this.$axios
					.post(url, formData, config)
					.then((response) => {
						if (response.data.status) {
							this.$swal("", response.data.message, "success");
						} else {
							this.$swal("", response.data.message, "error");
						}
						this.clearForm();
						this.closeModal();
						this.fetchVendors(this.active_page_url);
					})
					.catch((error) => {
						if (error.response) {
							if (error.response.data.message) {
								this.errors = error.response.data.message;
								this.$swal("", error.response.data.message, "error");
							} else {
								this.$swal("", "Something went wrong", "error");
							}
						} else {
							this.$swal("", "Something went wrong", "error");
						}
					})
					.finally(() => {
						this.submitting = false;
					});
			},

			clearForm() {
				this.edit = false;
				this.modal_title = "Add Vendor";
				this.button_title = "Add";
                this.vendor.vendor_type = "",
                this.vendor.name = "",
				this.vendor.mobile = "",
				this.vendor.email = "",
				this.errors = {};
			},

			

		},
	};
</script>